import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newPassword });
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-bbap-bg">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo showText={false} size="h-20" /></div>
        <div className="bg-white border border-zinc-200 rounded-sm p-8">
          <h1 className="font-display font-bold uppercase text-2xl text-zinc-950 text-center mb-6">Set New Password</h1>
          {success ? (
            <div data-testid="reset-password-success-message" className="p-4 rounded-sm bg-[#4FD1C5]/10 border border-[#4FD1C5]/40 text-[#1E3A6E] text-sm text-center">
              Password updated. Redirecting to log in...
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && <div className="p-3 rounded-sm bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>}
              <div>
                <Label htmlFor="newPassword" className="text-zinc-500 text-xs uppercase tracking-wide">New Password</Label>
                <Input
                  id="newPassword" type="password" required minLength={6} value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                  data-testid="reset-password-new-input"
                  className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
                />
              </div>
              <Button type="submit" disabled={loading} data-testid="reset-password-submit-button" className="w-full bg-zinc-950 text-white font-medium rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">
                {loading ? "Updating..." : "Update Password"}
              </Button>
            </form>
          )}
          <p className="text-center text-sm text-zinc-500 mt-6">
            <Link to="/login" className="text-[#1E3A6E] font-semibold hover:underline">Back to log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
